import {
  dna24ProfileAtom,
  genotypeStatusAtom,
} from 'dataLayer/recoil/apiData/atoms';
import { getAllTraits } from 'dataLayer/recoil/pages/helpers/traitHelpers';
import {
  allBeProductiveTraitsAtom,
  allEatFreshTraitsAtom,
  allergyTraitsAtom,
  allStayActiveTraitsAtom,
  beProductiveTraitsAtom,
  eatFreshTraitsAtom,
  hairTraitsAtom,
  skinTraitsAtom,
  stayActiveTraitsAtom,
} from 'dataLayer/recoil/pages/sections/atoms';
import { selector } from 'recoil';

export const eatFreshTraitsSelector = selector({
  key: 'apiData/pages/sections/selectors/eatFreshTraits/get',
  get: ({ get }) => {
    return {
      traitsData: get(eatFreshTraitsAtom),
      genotypeStatus: get(genotypeStatusAtom),
      allTraits: get(allEatFreshTraitsAtom),
    };
  },
});

export const beProductiveTraitsSelector = selector({
  key: 'apiData/pages/sections/selectors/beProductiveTraits/get',
  get: ({ get }) => {
    return {
      traitsData: get(beProductiveTraitsAtom),
      genotypeStatus: get(genotypeStatusAtom),
      allTraits: get(allBeProductiveTraitsAtom),
    };
  },
});

export const stayActiveTraitsSelector = selector({
  key: 'apiData/pages/sections/selectors/stayActiveTraits/get',
  get: ({ get }) => {
    return {
      traitsData: get(stayActiveTraitsAtom),
      genotypeStatus: get(genotypeStatusAtom),
      allTraits: get(allStayActiveTraitsAtom),
    };
  },
});

export const skinTraitsSelector = selector({
  key: 'apiData/pages/sections/selectors/skinTraits/get',
  get: ({ get }) => {
    return {
      traitsData: get(skinTraitsAtom),
      genotypeStatus: get(genotypeStatusAtom),
      allTraits: get(allStayActiveTraitsAtom),
    };
  },
});

export const allergyTraitsSelector = selector({
  key: 'apiData/pages/sections/selectors/allergyTraits/get',
  get: ({ get }) => {
    return {
      traitsData: get(allergyTraitsAtom),
      genotypeStatus: get(genotypeStatusAtom),
      allTraits: get(allStayActiveTraitsAtom),
    };
  },
});

export const hairTraitsSelector = selector({
  key: 'apiData/pages/sections/selectors/hairTraits/get',
  get: ({ get }) => {
    return {
      traitsData: get(hairTraitsAtom),
      genotypeStatus: get(genotypeStatusAtom),
      allTraits: get(allStayActiveTraitsAtom),
    };
  },
});

export const traitDetailsCompleteDataGet = selector({
  key: 'apiData/pages/sections/selectors/traitDetailsCompleteData/get',
  get: ({ get }) => {
    let dna24Profile = get(dna24ProfileAtom);
    const allTraits = getAllTraits(dna24Profile);

    return {
      allTraits,
    };
  },
});
